import React from "react";

import {
    Chord,
    Note,
    Tone
} from "../../model/core";
import { RydFretboard } from "../widgets/RydFretboard";
import { RydCollapsableCard } from "../widgets/RydCollapsableCard";
import { getToneColorBaseClassName } from "../../render/renderUtils";
import { ChordAliasPartition } from "../../utils/ChordAliasPartition";
import { Tonality } from "../../model/scales";


export const isToneCenter = (n: Note, root?: Tone) => n.getTone().index === root?.index
    ? ['piano-roll--tonality--center']
    : [];
const isInTonality = (n: Note, tonality?: Tonality) => {
    if (!tonality) return [];
    const isInTonality = tonality.containsNote(n);
    return isInTonality ? ["piano-roll--tonality-note"] : ["piano-roll--non-tonality-note"];
}

export function RydChordInfobox({
    chord
}: {
    chord: Chord
}) {
    return (<>
    <div>{chord.getName()}</div>
        <RydCollapsableCard title="Notes" >
            {chord.tones.map((n, i) => <span key={i}>{n.getName()} </span>)}
            <br />
            Partition:
            <ul>{ChordAliasPartition.get(chord)?.map((c, i) => {

                return <li key={i}>{c.getName()} </li>;
            })}
            </ul>

        </RydCollapsableCard>
        {/* <RydCollapsableCard title="Piano" >
            <RydIOKeybed
                noteRange={{ min: 24, max: 24 + 48 }}
                // orientation="keyboard"
                stylingSource={(note: Note) => [
                    (n) => [getToneColorBaseClassName(n.getTone())],
                    // (n) => isToneCenter(n, tonality.center),
                    // (n) => isInTonality(n, tonality),
                ]
                    .map((f) => f(note))
                    .flat()} />
        </RydCollapsableCard> */}
        <RydCollapsableCard title="Fretboard" >
            <RydFretboard config={{
                numberOfStrings: 6,
                numberOfFrets: 24,
                tuning: "E4, A4, D5, G5, B5, E6".split(',').map(note => Note.fromName(note.trim()).index)
            }}
                stylingSource={(note: Note) => {
                    return [
                        (n) => chord.tones.find((t) => n.getTone().index === t.index ) ? [getToneColorBaseClassName(n.getTone())]: ['note-disabled']
                    ].map((f) => f(note)).flat();
                }}
            />
        </RydCollapsableCard>
    </>);
}
